import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import { ReactSVG } from 'react-svg';
import styled, { ThemeContext } from 'styled-components';
import { compose, background, border, color, layout, position, shadow, space } from 'styled-system';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const setFillPropToCurrentColor = el => {
  var _el$setAttribute;
  return el === null || el === void 0 || (_el$setAttribute = el.setAttribute) === null || _el$setAttribute === void 0 ? void 0 : _el$setAttribute.call(el, 'fill', 'currentColor');
};
const errorIcon = (p /* props */, t /* theme */) => {
  const iconDimensions = p.iconSize ? p.iconSize.match('sm|md|lg|xl|xxl') // reference theme values
  ? t.iconSizes[p.iconSize] // theme value
  : p.iconSize.replace(/[\D]/g, '') == false //not theme value, so is it a number
  ? t.iconSizes.md //not a number, so use default from theme
  : p.iconSize.replace(/[\D]/g, '') // a number, so use that number
  : t.iconSizes.md; // no iconSize value so use default from theme
  return /*#__PURE__*/jsx(StyledSVGBox, _objectSpread(_objectSpread({
    size: "".concat(iconDimensions, "px")
  }, p), {}, {
    children: /*#__PURE__*/jsx("svg", {
      title: "Error Loading Icon" // cypress looks for this value
      ,

      focusable: p.focusable || false,
      role: p.role || 'presentation',
      style: {
        color: 'red'
      },
      fill: "currentColor",
      width: "".concat(iconDimensions, "px"),
      height: "".concat(iconDimensions, "px"),
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/jsxs("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [/*#__PURE__*/jsx("path", {
          strokeLinecap: "full",
          fill: "none",
          d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
        }), /*#__PURE__*/jsx("path", {
          fill: "none",
          strokeLinecap: "full",
          d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
        }), /*#__PURE__*/jsx("circle", {
          fill: "none",
          strokeMiterlimit: "10",
          cx: "12",
          cy: "12",
          r: "11.25"
        })]
      })
    })
  }));
};
const StyledSVGBox = styled('div').withConfig({
  displayName: "icon__StyledSVGBox",
  componentId: "ze23ln-0"
})(["transform:", ";", ""], props => {
  const rotation = props.degreesOfIconRotation ? "rotate(".concat(props.degreesOfIconRotation, "deg)") : '';
  const flip = props.flipOnXAxis && props.flipOnXAxis !== false ? 'scaleX(-1);' : '';
  const transformValue = "".concat(rotation, " ").concat(flip);
  return transformValue === '' ? 'none' : transformValue;
}, compose(background, border, color, layout, position, shadow, space));
const StyledSVG = styled('svg').withConfig({
  displayName: "icon__StyledSVG",
  componentId: "ze23ln-1"
})(["transform:", ";", ""], props => {
  const rotation = props.degreesOfIconRotation ? "rotate(".concat(props.degreesOfIconRotation, "deg)") : '';
  const flip = props.flipOnXAxis && props.flipOnXAxis !== false ? 'scaleX(-1);' : '';
  const transformValue = "".concat(rotation, " ").concat(flip);
  return transformValue === '' ? 'none' : transformValue;
}, compose(background, border, color, layout, position, shadow, space));
const Icon = /*#__PURE__*/forwardRef((props, ref) => {
  var _props$name;
  const themeContext = useContext(ThemeContext);
  const isIconColored = props === null || props === void 0 || (_props$name = props.name) === null || _props$name === void 0 ? void 0 : _props$name.includes('.color');
  const iconDimensions = props.iconSize ? props.iconSize.match('sm|md|lg|xl|xxl') // reference theme values
  ? themeContext.iconSizes[props.iconSize] // theme value
  : props.iconSize.replace(/[\D]/g, '') == false //not theme value, so is it a number
  ? themeContext.iconSizes.md //not a number, so use default from theme
  : props.iconSize.replace(/[\D]/g, '') // a number, so use that number
  : themeContext.iconSizes.md; // no iconSize value so use default from theme

  const iconWidth = props.narrow ? themeContext.narrowIconSizes[props.iconSize] || themeContext.narrowIconSizes.md : iconDimensions;
  const viewBox = props.viewBox || props.narrow && '5 0 22 32';
  return /*#__PURE__*/jsxs(Fragment, {
    children: [props.name && props.isUsingIconFromTheme === undefined && /*#__PURE__*/jsx(StyledSVGBox, _objectSpread(_objectSpread({
      ref: ref,
      width: "".concat(iconWidth, "px"),
      height: "".concat(iconDimensions, "px")
    }, props), {}, {
      children: /*#__PURE__*/jsx(ReactSVG, {
        focusable: props.focusable || false,
        role: props.role || 'presentation',
        beforeInjection: svg => {
          svg.setAttribute('style', 'flex-shrink: 0;  backface-visibility: hidden;');
          svg.setAttribute('stroke-width', '0');
          svg.setAttribute('width', props.width || "".concat(iconWidth, "px"));
          svg.setAttribute('height', props.height || "".concat(iconDimensions, "px"));
          if (viewBox) svg.setAttribute('viewBox', viewBox);
          if (!isIconColored) {
            var _svg$children, _svg$children$forEach;
            setFillPropToCurrentColor(svg);
            (_svg$children = svg.children) === null || _svg$children === void 0 || (_svg$children$forEach = _svg$children.forEach) === null || _svg$children$forEach === void 0 || _svg$children$forEach.call(_svg$children, setFillPropToCurrentColor);
          }
        },
        src: "".concat(themeContext.iconBaseURL).concat(props.name, ".svg"),
        fallback: () => {
          return errorIcon(props, themeContext);
        }
      })
    })), props.name && props.isUsingIconFromTheme === true && themeContext.icons[props.name] && /*#__PURE__*/jsx(StyledSVG, _objectSpread(_objectSpread({
      title: "Icon From Theme",
      fallback: () => {
        return errorIcon(props, themeContext);
      },
      ref: ref,
      fill: "currentColor",
      focusable: props.focusable || false,
      role: props.role || 'presentation',
      strokeWidth: "0",
      width: "".concat(iconDimensions, "px"),
      height: "".concat(iconDimensions, "px"),
      viewBox: "0 0 32 32"
    }, props), {}, {
      children: themeContext.icons[props.name].path
    })), props.name === undefined && errorIcon(props, themeContext)]
  });
});
Icon.displayName = 'Icon';
Icon.defaultProps = {
  'data-cy': 'Icon',
  // component name
  narrow: false
};
Icon.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  name: PropTypes.string.isRequired,
  isUsingIconFromTheme: PropTypes.bool,
  role: PropTypes.string,
  focusable: PropTypes.bool,
  iconSize: PropTypes.string,
  degreesOfIconRotation: PropTypes.number,
  flipOnXAxis: PropTypes.bool,
  narrow: PropTypes.bool
});
export default Icon;